import { PageHero } from "@/components/site/PageHero";
import { CTABand } from "@/components/site/CTABand";
import { ArticleCard } from "@/components/insights/ArticleCard";
import { ARTICLES } from "@/data/insights";

export default function Insights() {
  const [featured, ...rest] = ARTICLES;
  return (
    <main data-testid="beyond-page">
      <PageHero
        eyebrow="Beyond"
        lines={["Architecting growth", "from within."]}
        intro={
          <div className="space-y-4">
            <p className="font-display text-xl font-semibold text-[#0D9488] md:text-2xl" data-testid="beyond-subline">Rethinking how we work, live & lead.</p>
            <p data-testid="beyond-description">Beyond is a space for perspectives on people, leadership, workplace culture and human behaviour — exploring the ideas, experiences and everyday moments that shape us.</p>
          </div>
        }
        testId="beyond-hero"
      />
      <section className="mx-auto max-w-[1400px] px-6 py-20 lg:px-12 lg:py-28">
        <ArticleCard a={featured} large />
        <div className="mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {rest.map((a, i) => (
            <ArticleCard key={a.slug} a={a} i={i} />
          ))}
        </div>
      </section>
      <CTABand title="Let's simplify HR. Together." cta="Talk to KRIMZON" />
    </main>
  );
}
